import React from "react";

import Image from "next/image";

import EmbeddedLoanAppsIcon from "public/images/icons/enerflo-embedded-loan-apps-icon.svg";
import InstantQuotingIcon from "public/images/icons/enerflo-instant-quoting-icon.svg";
import SystemDetailsIcon from "public/images/icons/enerflo-system-details-icon.svg";

import Heading from "components/heading";
import HeroSection from "components/hero-section";

const items = [
  {
    title: "Instant Quoting",
    description:
      "Enerflo enables instant quoting for your lender products, taking into account project costs, adders, rebates and ITC calculations. Lender quotes are dynamically fed into Optimus, our proprietary (and industry game-changing!) proposal software for your customers.",
    image: InstantQuotingIcon,
    imageAlt: "Icon - Enerflo Instant Quoting",
  },
  {
    title: "Embedded Loan Apps",
    description:
      "With embedded loan applications, sales reps never leave Enerflo to apply, get customers approved or sign loan documents. The entire process, start to finish, is completed within Enerflo, including alerts and status updates that keep your solar customers informed on the status of their loan, in real time.",
    image: EmbeddedLoanAppsIcon,
    imageAlt: "Icon - Enerflo Embedded Loan Apps",
  },
  {
    title: "System Details",
    description:
      "Enerflo automatically updates loan applications with additional system, equipment and project details after the loan docs have been signed, ensuring the project and loan application are kept on track and in sync, getting the customer closer to NTP faster.",
    image: SystemDetailsIcon,
    imageAlt: "Icon - Enerflo System Detials",
  },
];

const title = "Solar Financing Made Simple";

const FinancingMadeSimple = () => (
  <HeroSection title={title}>
    <HeroSection.Content>
      <HeroSection.Header>
        <Heading tag="h2">{title}</Heading>
      </HeroSection.Header>
      <p className="text-lg text-gray-500 mx-auto md:text-center md:w-3/4 lg:w-2/3">
        Our deep integrations with the top solar lenders makes loan application, approvals and doc signing a breeze.
        Reps no longer need to login to multiple lending platforms. Everything can be done within Enerflo’s Lendflo
        platform.
      </p>

      <div className="flex flex-col space-y-4 md:space-y-0 md:space-x-4 lg:space-x-6 mt-8 md:mt-20 md:flex-row">
        {items.map(item => (
          <div key={item.title} className="flex-1 rounded-lg shadow-lg border-2 border-primary p-4 md:py-8 text-center">
            <figure className=" h-14 w-14 md:h-20 md:w-20 mx-auto">
              <Image src={item.image} alt={item.imageAlt} />
            </figure>
            <Heading tag="h5" className="mt-3 md:mt-6">
              {item.title}
            </Heading>
            <p className="mt-2 text-gray-500 text-base">{item.description}</p>
          </div>
        ))}
      </div>
    </HeroSection.Content>
  </HeroSection>
);

export default FinancingMadeSimple;
